module.exports = __webpack_public_path__ + "media/images/responsive/logo/service/logo_ashery-a6aa1168b004744d3ebe3c05a55725cc.svg";